module.exports = __webpack_public_path__ + "media/images/athletes/3523-627024ba877ed49b2d7004fc56ce81d9.png";